import Loading from "vue-loading-overlay";
import mixin from "../../../mixin";
export default {
    name: "PaymentInfo",
    mixins: [mixin],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            setPaymentMethod: 'set-payment-method',
            getPaymentMethodURL: 'get-payment-method',
            paymentMethodData: [],
            cartJsonString: localStorage.getItem('cart'),
            cartPurchaseJsonString: localStorage.getItem('purchase_cart'),
            totalcartData:{},
            auth: [],
            checkAuth: false,
            myCart: 0,
            hideCart: false,
            hideEmptyCart: true,
            paypalInfoBox: false,
            venmoInfoBox: false,
            cashAppInfoBox: false,
            bankDetailBox: false,
            nextPaymentSelection: false,
            cashOnDelivery: false,
            choosenPaymentMethod: 0,
            signupBoxActive: '',
            paypalName: '',
            paypalEmail: '',
            bankName: '',
            bankACNo: '',
            bankBranch: '',
            customerDetailRoute: {name: 'Checkout'}, 
            
        }
    },
    mounted() {
        if(!this.$route.params.backurl)
        {
            console.log("Working...");
        }  
        else
        {
            console.log('Working with Back URL', this.$route.params.backurl);
            this.customerDetailRoute = {name: 'customerShippingDetailWithBackUrl', params: {backurl: this.$route.params.backurl}};        
            this.setPaymentMethod = "purchase/set-payment-method";
        }   
    },
    created() {
        console.log('this.cartJsonString = ', this.cartJsonString);
        console.log('this.cartPurchaseJsonString = ',this.cartPurchaseJsonString);
        this.totalcartData = this.loadCartMixin(this.cartJsonString,this.cartPurchaseJsonString); 
        console.log('this.totalcartData = ',this.totalcartData);
        this.getPaymentMethod(); 
        this.checkAuthentication();
    },
    methods:{
        showMessage: function(typeMessage, title, detailMessage)
        {
            this.$swal.fire(
                title,
                detailMessage,
                typeMessage
            );
            return false;
        },
        checkFieldValidation(fieldName)
        {
            if(typeof(fieldName) != 'undefined')
            {
                if(fieldName == null)
                {
                    return true;
                }
                else if(fieldName.length == 0)
                {
                    return true;
                }
                else
                {
                    return false;
                } 
            }
            else 
            {
                return true;
            }
        },
        getPaymentMethod: function() {
            this.isLoading = true;
            this.$axios.get(this.$api + "api/" + this.getPaymentMethodURL).then(response => {
                this.paymentMethodData = response.data;
                this.isLoading = false;
            }).catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        choosePaymentMethod: function(paymentMethod){
            this.venmoInfoBox= false;
            this.paypalInfoBox = false;
            this.cashOnDelivery = false;
            this.cashAppInfoBox = false;
            if(paymentMethod == 1)
            {
                this.bankDetailBox = false;
                this.cashOnDelivery = false;
                this.paypalInfoBox = true;
                this.nextPaymentSelection = true; 
            }
            else if(paymentMethod == 2)
            {
                this.paypalInfoBox = false;
                this.bankDetailBox = false;
                this.cashOnDelivery = true;
                this.nextPaymentSelection = true;
            }
            else if(paymentMethod == 3)
            {
                this.paypalInfoBox = false;
                this.cashOnDelivery = false;
                this.bankDetailBox = true;
                this.nextPaymentSelection = true;
            }
            else if(paymentMethod == 4)
            {
                this.bankDetailBox = false;
                this.cashOnDelivery = false;
                this.venmoInfoBox= true;
                this.nextPaymentSelection = true; 
            }
            else if(paymentMethod == 5)
            {
                this.paypalInfoBox = false;
                this.bankDetailBox = false;
                this.cashAppInfoBox = true;
                this.nextPaymentSelection = true;
            }
            this.choosenPaymentMethod = paymentMethod;
        },
        backToSellBox: function()
        {
            if(!this.$route.params.backurl)
            {
                this.$router.push({name: 'Cart'});    
            }
            else
            {
                //this.$router.push({name: 'buyCartBox'});               
            }
        },
        showShippingDetail: function(){
            let formData = new FormData();
            formData.append('paymentMethod', this.choosenPaymentMethod);
            if(this.choosenPaymentMethod == 1 || this.choosenPaymentMethod == 4 || this.choosenPaymentMethod == 5)
            {
                if(this.paypalName.trim().length == 0)
                {
                    this.showMessage('warning','Require Field Missing', 'Please enter your Paypal name.');
                    return false;
                }
                if(this.paypalEmail.trim().length == 0)
                {
                    this.showMessage('warning','Require Field Missing', 'Please enter your Paypal email.');
                    return false;
                }
                formData.append('paypalName', this.paypalName);
                formData.append('paypalEmail', this.paypalEmail);
            }
            else if(this.choosenPaymentMethod == 2) {
                // this.$axios.post(this.$api + 'api/' + this.setPaymentMethod, formData).then(response => {
                //     console.log(response);
                //     this.$router.push(this.customerDetailRoute);
                // }).catch(e => {
                //     console.log(e);
                // });
            }
            else if(this.choosenPaymentMethod == 3)
            {
                if(this.bankName.trim().length == 0)
                {
                    this.showMessage('warning','Require Field Missing', 'Please enter your bank name.');
                    return false;
                }
                if(this.bankACNo.trim().length == 0)
                {
                    this.showMessage('warning','Require Field Missing', 'Please enter your bank A/C No.');
                    return false;
                }
                if(this.bankBranch.trim().length == 0)
                {
                    this.showMessage('warning','Require Field Missing', 'Please enter your bank branch name.');
                    return false;
                }
                formData.append('bankName', this.bankName);
                formData.append('bankACNo', this.bankACNo);
                formData.append('bankBranch', this.bankBranch);
            }
            this.isLoading = true;
            this.$axios.post(this.$api + 'api/' + this.setPaymentMethod, formData).then(response => {
                console.log(response);
                this.isLoading = false;
                let cart = JSON.parse(this.cartJsonString);
                let cartPurchase = JSON.parse(this.cartPurchaseJsonString);
                console.log('cart = ', cart);
                console.log('cartPurchase = ',cartPurchase);
                console.log('cartOld = ',this.totalcartData);

                if(cart!=null)
                {
                    cart.payment=response.data;
                    let sellDeviceCartString=JSON.stringify(cart);
                    console.log('Type of object = ',typeof(sellDeviceCartString));
                    localStorage.setItem('cart',sellDeviceCartString);
                    console.log(' sellDeviceCartString = ',sellDeviceCartString);
                }

                if(cartPurchase!=null)
                {
                    cartPurchase.payment=response.data;
                    let purchaseDeviceCartString=JSON.stringify(cartPurchase);
                    console.log('Type of object = ',typeof(purchaseDeviceCartString));
                    localStorage.setItem('purchase_cart',purchaseDeviceCartString);
                    console.log('purchaseDeviceCartString = ', purchaseDeviceCartString);
                }
                
                this.$router.push(this.customerDetailRoute);    
            }).catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        }
    }
}